import { baseFocusGtmEvent, baseFormSubmitGtmEvent } from '@/logic/metrika/constants'
import type { IFormattedGtmEventPayload } from '@/logic/metrika/interfaces'

export enum EHarvestSaleGtmSubmitName {
  submitOfferForm = 'submitOfferForm',
}

export const HarvestSaleLotsSubmittingGtmEventPayload: Record<EHarvestSaleGtmSubmitName, IFormattedGtmEventPayload> = {
  [EHarvestSaleGtmSubmitName.submitOfferForm]: {
    ...baseFormSubmitGtmEvent,
    pagePart: 'popUp',
    blockName: null,
    eventStatus: 'success',
  },
}

export enum EHarvestSaleGtmFieldName {
  culture = 'cultureId',
  nature = 'quality.nature',
  fusarios = 'quality.fusarios',
  humidity = 'quality.humidity',
  infection = 'quality.infection',
  proteinFrom = 'quality.proteinFrom',
  cultureClass = 'quality.cultureClass',
  weedAdmixture = 'quality.weedAdmixture',
  grainAdmixture = 'quality.grainAdmixture',
  deliveryBasis = 'deliveryOptions.deliveryBasisId',
  volume = 'volume',
  desiredPrice = 'desiredPrice',
  departureDate = 'deliveryOptions.departureDate',
  store = 'deliveryOptions.storeId',
  elevator = 'regionCode',
  idk = 'quality.idk',
  gluten = 'quality.gluten',
  vitreousness = 'quality.vitreousness',
  fallingNumber = 'quality.fallingNumber',
  comment = 'comment',
}

export const HarvestSaleLotsFocusingGtmEventPayload: Record<EHarvestSaleGtmFieldName, IFormattedGtmEventPayload> = {
  [EHarvestSaleGtmFieldName.culture]: {
    ...baseFocusGtmEvent,
    pagePart: 'popUp',
    eventLabel: 'focusCrop',
    blockName: 'submitApplication',
  },
  [EHarvestSaleGtmFieldName.nature]: {
    ...baseFocusGtmEvent,
    pagePart: 'popUp',
    eventLabel: 'focusQualityNature',
    blockName: 'submitApplication',
  },
  [EHarvestSaleGtmFieldName.fusarios]: {
    ...baseFocusGtmEvent,
    pagePart: 'popUp',
    eventLabel: 'focusFusarium',
    blockName: 'submitApplication',
  },
  [EHarvestSaleGtmFieldName.humidity]: {
    ...baseFocusGtmEvent,
    pagePart: 'popUp',
    eventLabel: 'focusMoisture',
    blockName: 'submitApplication',
  },
  [EHarvestSaleGtmFieldName.infection]: {
    ...baseFocusGtmEvent,
    pagePart: 'popUp',
    eventLabel: 'focusContamination',
    blockName: 'submitApplication',
  },
  [EHarvestSaleGtmFieldName.proteinFrom]: {
    ...baseFocusGtmEvent,
    pagePart: 'popUp',
    eventLabel: 'focusProtein',
    blockName: 'submitApplication',
  },
  [EHarvestSaleGtmFieldName.cultureClass]: {
    ...baseFocusGtmEvent,
    pagePart: 'popUp',
    eventLabel: 'focusClass',
    blockName: 'submitApplication',
  },
  [EHarvestSaleGtmFieldName.weedAdmixture]: {
    ...baseFocusGtmEvent,
    pagePart: 'popUp',
    eventLabel: 'focusQualityWeedAdmixture',
    blockName: 'submitApplication',
  },
  [EHarvestSaleGtmFieldName.grainAdmixture]: {
    ...baseFocusGtmEvent,
    pagePart: 'popUp',
    eventLabel: 'focusQualityGrainAdmixture',
    blockName: 'submitApplication',
  },
  [EHarvestSaleGtmFieldName.deliveryBasis]: {
    ...baseFocusGtmEvent,
    pagePart: 'popUp',
    eventLabel: 'focusDeliveryBasis',
    blockName: 'submitApplication',
  },
  [EHarvestSaleGtmFieldName.volume]: {
    ...baseFocusGtmEvent,
    pagePart: 'popUp',
    eventLabel: 'focusBatchSize',
    blockName: 'submitApplication',
  },
  [EHarvestSaleGtmFieldName.desiredPrice]: {
    ...baseFocusGtmEvent,
    pagePart: 'popUp',
    eventLabel: 'focusDesiredPrice',
    blockName: 'submitApplication',
  },
  [EHarvestSaleGtmFieldName.departureDate]: {
    ...baseFocusGtmEvent,
    pagePart: 'popUp',
    eventLabel: 'focusDeliveryTime',
    blockName: 'submitApplication',
  },
  [EHarvestSaleGtmFieldName.store]: {
    ...baseFocusGtmEvent,
    pagePart: 'popUp',
    eventLabel: 'focusAddress',
    blockName: 'submitApplication',
  },
  [EHarvestSaleGtmFieldName.elevator]: {
    ...baseFocusGtmEvent,
    pagePart: 'popUp',
    eventLabel: 'focusElevator',
    blockName: 'createApplication',
  },
  [EHarvestSaleGtmFieldName.idk]: {
    ...baseFocusGtmEvent,
    pagePart: 'popUp',
    eventLabel: 'focusIDC',
    blockName: 'submitApplication',
  },
  [EHarvestSaleGtmFieldName.gluten]: {
    ...baseFocusGtmEvent,
    pagePart: 'popUp',
    eventLabel: 'focusQualityGluten',
    blockName: 'submitApplication',
  },
  [EHarvestSaleGtmFieldName.vitreousness]: {
    ...baseFocusGtmEvent,
    pagePart: 'popUp',
    eventLabel: 'focusVitreousness',
    blockName: 'submitApplication',
  },
  [EHarvestSaleGtmFieldName.fallingNumber]: {
    ...baseFocusGtmEvent,
    pagePart: 'popUp',
    eventLabel: 'focusQualityFallingNumber',
    blockName: 'submitApplication',
  },
  [EHarvestSaleGtmFieldName.comment]: {
    ...baseFocusGtmEvent,
    pagePart: 'popUp',
    eventLabel: 'focusComment',
    blockName: 'submitApplication',
  },
}
